import { IStore } from 'constants/storeTypes';

export const getHasToken = (store: IStore) => store.dataStorage.hasToken;
